module.exports = __webpack_public_path__ + "static/media/Werner Ave Daly City, CA (3 Houses)5.d8cc7cf9.jpg";